import { Box, Button, CircularProgress, IconButton, Tooltip } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export default function QuickbooksActionsCell({
  row,
  syncingCustomerIds,
  connectingCustomerId,
  onConnect,
  onSync,
  onOpenMenu,
}) {
  const customerForAction = row?.originalCustomer || row;
  const customerId = customerForAction?.id;

  const isConnected = Boolean(
    row?.isQBConnected || customerForAction?.quickbooks_connected_for_user
  );

  const connectLoading = Boolean(
    customerId && connectingCustomerId && customerId === connectingCustomerId
  );

  const isSyncing =
    customerId &&
    syncingCustomerIds instanceof Set &&
    syncingCustomerIds.has(customerId);

  const syncTooltip = isConnected
    ? isSyncing
      ? "Sync in progress..."
      : "Sync QuickBooks data"
    : "Connect to QuickBooks first";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Tooltip
          title={
            isConnected
              ? "Already connected to QuickBooks"
              : "Connect this account to QuickBooks"
          }
        >
          <span>
            <Button
              size="small"
              variant="outlined"
              disabled={connectLoading || isConnected || !onConnect}
              startIcon={
                connectLoading ? (
                  <CircularProgress size={14} sx={{ color: "#627CFB" }} />
                ) : null
              }
              onClick={(event) => {
                event.stopPropagation();
                if (!isConnected && onConnect && !connectLoading) {
                  onConnect(customerForAction);
                }
              }}
              sx={{
                backgroundColor: "white",
                color: "#627CFB",
                borderColor: "#627CFB",
                textTransform: "none",
                fontSize: "0.875rem",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: "rgba(98, 124, 251, 0.04)",
                  borderColor: "#627CFB",
                },
                "&.Mui-disabled": {
                  color: "#9CA3AF",
                  borderColor: "#E5E7EB",
                },
              }}
            >
              {connectLoading ? "Connecting" : isConnected ? "Connected" : "Connect"}
            </Button>
          </span>
        </Tooltip>

        <Tooltip title={syncTooltip}>
          <span>
            <Button
              size="small"
              variant="outlined"
              disabled={!isConnected || !onSync || isSyncing}
              startIcon={
                isSyncing ? (
                  <CircularProgress size={14} sx={{ color: "#627CFB" }} />
                ) : null
              }
              onClick={(event) => {
                event.stopPropagation();
                if (isConnected && onSync && !isSyncing) {
                  onSync(customerForAction);
                }
              }}
              sx={{
                backgroundColor: "white",
                color: "#627CFB",
                borderColor: "#627CFB",
                textTransform: "none",
                fontSize: "0.875rem",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: "rgba(98, 124, 251, 0.04)",
                  borderColor: "#627CFB",
                },
                "&.Mui-disabled": {
                  color: "#9CA3AF",
                  borderColor: "#E5E7EB",
                },
              }}
            >
              {isSyncing ? "Syncing" : "Sync"}
            </Button>
          </span>
        </Tooltip>
      </Box>

      <Box sx={{ marginLeft: "auto" }}>
        <Tooltip title="More actions">
          <IconButton
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              if (onOpenMenu) {
                onOpenMenu(event, customerForAction);
              }
            }}
            sx={{ color: "#6B7280" }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}